import {Note} from "./../../models/Note";

let notesApi = {
    async getByUser(userId, token, companyId){
        return this.get('user', userId, token, companyId)
    },
    async getByDeal(dealId, token, companyId){
        return this.get('deal', dealId, token, companyId)
    },
    async get(type, id, token, companyId){
        let response = await window.axios.get('/api/notes/'+type+'/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.map(n=>new Note(n));
    },
    async create(note, token, companyId){
        let response = await window.axios.post('/api/notes', note, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Note(response.data.data);
    },
    async edit(note, token, companyId){
        let response = await window.axios.put('/api/notes/'+note.id, note, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Note(response.data);
    },
    async delete(note, token, companyId){
        let response = await window.axios.delete('/api/notes/'+note.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default notesApi